'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import {
  captureLandingOnce,
  trackPageVisit,
} from '@shared/utils/visitTracking';

/**
 * 세션 스코프 트래킹 캡처 — AppProviders 에 마운트 (AttributionCapture 옆).
 *
 * 책임:
 * - 세션 첫 진입의 landing/referrer 1회 영속
 * - pathname 변화 추적 → prevVisitedPage (폼 진입 직전 페이지)
 *
 * UTM/gclid/fbclid 는 `AttributionCapture` 가 localStorage 30일로 담당한다.
 */
export function LeadTrackingCapture() {
  const pathname = usePathname();

  // landing + referrer 세션 1회 캡처 — 마운트 시점에만 실행.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    captureLandingOnce(window.location.pathname, document.referrer);
  }, []);

  // 페이지 방문 추적 — pathname 변화 시점에 직전 path 를 prev 로 승격.
  useEffect(() => {
    trackPageVisit(pathname);
  }, [pathname]);

  return null;
}
